<template>
    <b-tab title="Câu hỏi thường gặp">
    	<b-card-text>
	      <div class="faq-list" role="tablist">
	        <!-- <p>{{trainingDetails}}</p> -->
	        <b-card no-body v-for="(item, index) of ebookFAQ" class="">
	          <b-card-header header-tag="header" role="tab" @click="openCollapse(`qa_${index}`)">
	            <div class="qa-head display-flex justify-content-md-between full-width">
	              <span class="font-sanpro-semibold primary-color font-size-16" v-html="item.question"></span>
	            </div>
	          </b-card-header>
	          <b-collapse :id="`qa_${index}`" accordion="my-accordion" role="tabpanel">
	            <b-card-body>
	              <div class="qa-body primary-color-txt font-size-16" v-html="item.answer"></div>
	            </b-card-body>
	          </b-collapse>
	        </b-card>
	      </div>
	    </b-card-text>
    </b-tab>
</template>

<script>
	import { mapGetters } from "vuex";
	import { STORE_KEY } from "../_store/constants";

	export default {
		name: 'EbookDetail_FAQ',
		data() {
			return {
        		id: this.$route.params.id
			};
		},
	    watch: {
	      '$route.params.id': function (id) {
	        this.$store.dispatch(STORE_KEY + '/getBookFAQ', id);
	      }
	    },
	    mounted() {
	      this.$store.dispatch(STORE_KEY + '/getBookFAQ', this.$route.params.id);
	    },	    
	    computed: {
	      ...mapGetters({
	        ebookFAQ: STORE_KEY + '/ebookFAQ'
	      })
	    },
		methods: {
			openCollapse(id) {
		      this.$root.$emit("bv::toggle::collapse", id);
		   },
		},
	};
</script>


<style lang="scss">

$cl-xam: #879AA9;
$cl-xanh: #124ABE;
.faq-list {
  margin-top: 20px;
  header {
    border-bottom: 0;
  }

  .card {
    margin-bottom: 20px;
    border-radius: 10px;
    border: solid 1px #f3f6fb;
    padding: 20px;
    background: #f3f6fb;
  }

  .card-header {
    padding: 0 !important;
    overflow: hidden;
  }

  .qa-head,
  .collapse {
    background: #f3f6fb;
  }

  .qa-head {
    button.dropdown-toggle {
      padding: 0;
      height: auto;

      &:focus,
      &:active,
      &:visited {
        background-color: none;
        border-color: none;
        outline: 0;
      }
    }
  }

  .card-body {
  	padding: 0px !important;
  	margin-top: 20px;
    .qa-body {
      border-top: 1px solid #d1d1d1;
      padding: 20px 0px 0px 0px;    
    }
  }

  .collapse {
    border-radius: 0 0 10px 10px;
  }
}

</style>